import { render, staticRenderFns } from "./TokenExpired.vue?vue&type=template&id=2fbac796"
import script from "./TokenExpired.vue?vue&type=script&lang=js"
export * from "./TokenExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports